import React from 'react';
import { Inbox, LucideIcon } from 'lucide-react';
import styles from './EmptyState.module.scss';

interface EmptyStateProps {
  title?: string;
  message?: string;
  Icon?: LucideIcon;
}

const EmptyState: React.FC<EmptyStateProps> = ({
  title = 'No hay elementos',
  message = 'No se encontraron resultados para mostrar',
  Icon = Inbox
}) => {
  return (
    <div className={styles.emptyState}>
      <Icon size={80} className={styles.icon} />
      <h3 className={styles.title}>{title}</h3>
      <p className={styles.message}>{message}</p>
    </div>
  );
};

export default EmptyState;

